import React from 'react'
import { withTranslation } from "react-i18next";
import { Tooltip as ReactTooltip } from "react-tooltip"; 
import 'react-tooltip/dist/react-tooltip.css';

const Tooltip = (props) => {
  return (
    <ReactTooltip
      id={props.id}
      place={props.place}
      style={{ maxWidth: '399px', backgroundColor: '#00467f', color: 'white', whiteSpace: 'pre-line', zIndex: '999' }}
    />
  )
};

export default withTranslation()(Tooltip);

